import React from 'react';

import classes from './RightImageColumn.module.scss';

interface RightImageColumnProps {
    image: string;
}

export const RightImageColumn: React.FC<RightImageColumnProps> = props => {
    return <img src={props.image} className={classes.root} />;
};
